import { computed, observable, autorun, action } from "mobx";
import { isPortal } from "../modules/utils";


class PortalStore {
  constructor() {
    this.restore();
    autorun((reaction) => {
      localStorage.setItem(this.LS_KEY, JSON.stringify(this.storage));
    });
  }

  LS_KEY = 'beacon-portal';
  isPortal = isPortal();

  @observable
  producerCode = null;

  @observable
  producerName = null;

  @observable
  location = null;

  @computed
  get storage() {
    return {
      producerCode: this.producerCode,
      location: this.location,
      producerName: this.producerName,
    };
  }

  @computed
  get isSet() {
    return Boolean(this.producerCode && this.location && this.producerName);
  }

  @action
  restore() {
    let storage = localStorage.getItem(this.LS_KEY);
    storage = JSON.parse(storage) || this.storage;
    this.producerCode = storage.producerCode;
    this.producerName = storage.producerName;
    this.location = storage.location;
  }

  @action
  clear() {
    this.producerName = null;
    this.producerCode = null;
    this.location = null;
    localStorage.removeItem(this.LS_KEY);
  }
}

export default PortalStore;


// WEBPACK FOOTER //
// ./src/store/portalStore.js